import React from 'react';
import { Controller } from 'react-hook-form';
import { FormLabel } from './FormLabel';

export const FormRadioButtons = ({
  control,
  name,
  label,
  rules,
  options,
  onChange: externalOnChange,
  disabled = false,
}) => {
  return (
    <>
      {label && <FormLabel rules={rules} label={label} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState }) => (
          <div className="d-flex flex-row pt-1">
            {options.map((option) => (
              <div key={option.value} className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  value={option.value}
                  id={`${name}-${option.value}`}
                  checked={value === option.value}
                  disabled={disabled}
                  onChange={() => {
                    // Update the field value in the form state
                    onChange(option.value);
                    // Call the external onChange handler, if provided
                    if (externalOnChange) {
                      externalOnChange(option.value);
                    }
                  }}
                />
                <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
                  <b>{option.label}</b>
                </label>
              </div>
            ))}
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </div>
        )}
      />
    </>
  );
};

export default FormRadioButtons;
